import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';

import ChartCard from '../../ChartComponents/ChartCard';
import BarChart from '../../ChartComponents/BarChart';

import { getPercentage } from '../../utils';
import Info from '../../../../components/Info';

const GenderChart = () => {
  const emotions = useSelector(({ analytics: { briziVision: { data } } }) => data?.emotions);

  // Process emotions data
  const chartData = useMemo(() => {
    if (isEmpty(emotions)) {
      return [];
    }

    const emotionsObj = {};

    Object.entries(emotions).forEach(([key, values]) => {
      const value = values.reduce((prev, next) => (prev + next.y), 0);
      emotionsObj[key] = value;
    });

    const totalAmount = Object.values(emotionsObj).reduce((prev, curr) => (prev + curr), 0);

    return Object.entries(emotionsObj).map(([key, value]) => ({
      name: key,
      total: value,
      percentage: getPercentage(value, totalAmount),
    }));
  }, [emotions]);

  if (!isEmpty(chartData)) {
    return (
      <ChartCard
        title={<Info label="Emotions" content="The number of different facial expressions captured in AmplifiCam photos" className="ml-2" />}
      >
        <BarChart
          barColor="var(--theme-red)"
          data={chartData}
          xAxisKey="name"
          barKey="total"
          labelKey="percentage"
          hideYAxis
          renderLabel
        />
      </ChartCard>
    );
  }

  return null;
};

export default GenderChart;
